import {Routes} from '@angular/router';
import {AuthLayoutComponent} from './core/layout/auth-layout.component';
import {loginGuard} from './core/auth/guards/login.guard';
import {AppLayoutComponent} from './core/layout/app-layout.component';
import {authGuard} from './core/auth/guards/auth.guard';
import {roleGuard} from './core/auth/guards/role.guard';

export const routes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		redirectTo: 'dashboard'
	},

	{
		path: '',
		component: AuthLayoutComponent,
		children: [
			{
				path: 'login',
				canActivate: [loginGuard],
				loadChildren: () =>
					import('./features/auth/login.routes')
						.then(r => r.LOGIN_ROUTES)
			}
		]
	},

	{
		path: '',
		component: AppLayoutComponent,
		canActivate: [authGuard],
		children: [
			{
				path: '',
				pathMatch: 'full',
				redirectTo: 'dashboard'
			},
			{
				path: 'dashboard',
				loadComponent: () =>
					import('./features/dashboard/dashboard.component')
						.then(c => c.DashboardComponent)
			},

			{
				path: 'tickets/:category',
				loadComponent: () =>
					import('./features/tickets/pages/tickets')
						.then(c => c.Tickets)
			},

			{
				path: 'tickets/:category/:ticketCode',
				loadComponent: () =>
					import('./features/tickets/pages/tickets')
						.then(c => c.Tickets)
			},

			{
				path: 'utenti',
				canActivate: [roleGuard],
				data: { roles: ['TENANT_ADMIN', 'MAILBOX_ADMIN'] },
				loadComponent: () =>
					import('./features/users/pages/user-list/users.component')
						.then(c => c.UsersComponent)
			}
		]
	}
];
